/**
* @class CmsFormsParserService
* @memberof module:"7Shop.Core"
*/
/* @ngInject */
function CmsFormsParserService($translate, datepickerHelperService) {
  /**
     * @memberOf CmsFormsParserService
     */
  var self = this;

  this.getDependableFields = function (dependableFieldName, form) {
    const { dependentRequired } = form;

    if (!dependentRequired) return [];

    return dependentRequired[dependableFieldName] || [];
  };

  this.getDependentField = function (fieldName, form) {
    const { dependentRequired } = form;
    let dependantName;

    if (!dependentRequired) {
      return undefined;
    }

    Object.entries(dependentRequired).forEach(([value]) => {
      const isIncluded = dependentRequired[value].includes(fieldName);
      if (isIncluded) dependantName = value;
    });

    return dependantName;
  };

  this.getControlVisibility = function (fieldName, form) {
    const dependantName = this.getDependentField(fieldName, form);

    if (!dependantName) return true;
    /**
     * In situation when current field is dependable on some other field (dependant),
     * if dependant's default value is true then its dependable fields should be visible too immediatelly.
     * Otherwise, we hide dependable fields for it since them should be visible only in situations when
     * dependant value is true (ex. checkbox is checked).
     */
    return form.properties[dependantName].default;
  };

  this.generateDateControls = function (formName, name) {
    const list = [];
    const translPrefix = formName === 'birthDate' ? 'date' : `player.${name}`; // we need this adjustment because of the old forms
    const controls = {
      dateDay: {
        datePart: 'Day',
        name: `${translPrefix}_day`
      },
      dateMonth: {
        datePart: 'Month',
        name: `${translPrefix}_month`
      },
      dateYear: {
        datePart: 'Year',
        name: `${translPrefix}_year`
      }
    };

    angular.forEach(controls, function (control) {
      list.push({
        control: {
          name: 'input',
          type: 'text'
        },
        name: formName,
        label: $translate.instant(control.name),
        placeholder: $translate.instant(control.name),
        source: control,
        readonly: false,
        visible: true,
        required: true
      });
    });

    return list;
  };

  this.getDateFormatted = function (dateObj) {
    var dateCopy = angular.copy(dateObj);
    dateCopy.month -= 1; // Months are zero based. ToDo: Fix this with new version of datepicker
    return datepickerHelperService.createDate(dateCopy, 'yyyy-MM-dd');
  };

  this.parseCMSForm = function (form) {
    var focusIdx = 1;
    var fields = [];

    angular.forEach(form.properties, function (el) {
      if (el.pattern) {
        el.pattern = RegExp.apply(
          undefined,
          /^\/(.*)\/(.*)/.exec(el.pattern).slice(1)
        );
      }

      el.visible = self.getControlVisibility(el.name, form);

      if (form.required.includes(el.name)) {
        el.required = true;
      } else {
        el.required = false;
      }

      if (el.control === 'controls') {
        el.controls = self.generateDateControls(el.formName, el.name);

        if (el.controls) {
          angular.forEach(el.controls, function (control) {
            control.focusIdx = focusIdx;
            focusIdx += 1;
            control.nextFocusIdx = focusIdx;
          });
        }
      } else if (el.visible && el.control !== 'file') {
        el.focusIdx = focusIdx;
        focusIdx += 1;
        el.nextFocusIdx = focusIdx;
      }

      fields.push(el);
    });

    return fields;
  };
}

export default CmsFormsParserService;
